export const NONE = 'NONE';
